export class User {
	accountType: number;
	agency: number;
	accountNumber: string;
	name: string;
	loggedUserName: string;
	cpfCnpj: string;
	personType: string;
	accountName: string;
	cpf: string;
	rule = '';
	tokenSms = false;
	accessPix = false;

	constructor() { }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/models/user.ts